import React from "react";
import imageWeb3 from "assets/images/web3-2.svg";
import { Image } from "react-bootstrap";

export default function Web3() {
  return (
    <div className="home-from-web3">
      <div className="container-lg">
        <div className="row justify-content-between align-items-center flex-column-reverse flex-lg-row">
          <div className="col-lg-6 mt-5 mt-lg-0 text-center text-lg-start">
            <h2 className="mb-3 heading-4">From Web 1.0 to Web3</h2>

            <p className="lead text-body-2 d-inline-flex flex-column">
              {`The revolution of technologies has grown dramatically. Web 1.0 demonstrated the power of the internet in the early days. Today, Web 2.0 dominates the market with a few powerful companies controlling the share.`}

              <strong className="lead text-body-2 mt-4">
                {`We provide solutions that retain the key strengths of Web 2.0 while combining the benefits of Web3 technologies — because we believe Web3 is how people are truly meant to interact through the internet.`}
              </strong>
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-8 text-center">
            <Image
              src={imageWeb3}
              alt="Web 1.0 to Web3 evolution"
              style={{ maxWidth: "420px", width: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
